import styled from 'styled-components';

const SelectionContainer = styled.div`
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: space-between;
  flex: 1;
`;

export default SelectionContainer;
